import { DialogContent, DialogDescription, DialogTitle } from '@discover-ui/dialog';
import Link from '@discover-ui/link';
import React from 'react';
import { PD6665VoucherImage } from '@/components/analytics/experiments/PD6665NewUserDiscount';

const EXIT_MODAL_SIGN_UP_URL = '/auth/sign-up?code=CREDITME';

type FreeCreditExitModalContentProps = {
  dinerCountFormatted: string;
  currency: string;
  onCtaClick: () => void;
};

export default function FreeCreditExitModalContent({
  dinerCountFormatted,
  currency,
  onCtaClick,
}: FreeCreditExitModalContentProps) {
  return (
    <DialogContent
      className="max-h-[90dvh] min-h-0 max-w-[441px] gap-0 overflow-hidden p-1.5 supports-[height:100dvh]:max-h-[90dvh] xs:rounded-[20px]"
      closeButtonClassName="right-3 top-3 flex items-center justify-center rounded-full bg-white opacity-100 shadow-sm"
      closeIconClassName="text-ds-gray-light-500">
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
        <div className="rounded-2xl bg-ds-gold-100">
          <PD6665VoucherImage currency={currency} />
        </div>
        <div className="px-6 py-4 text-center">
          <span className="text-xs font-semibold text-ds-brand-700">First Table welcome offer</span>
          <DialogTitle className="font-serif text-lg font-normal sm:text-xl">
            Claim your free credit
          </DialogTitle>
          <DialogDescription className="mt-3 text-base text-ds-black">
            Join {dinerCountFormatted} diners already saving 50% off food at top restaurants
            worldwide
          </DialogDescription>
          <Link
            href={EXIT_MODAL_SIGN_UP_URL}
            kind="normal"
            scale="lg"
            width="wide"
            className="mt-4 rounded-lg bg-ds-brand-700 p-3"
            onClick={onCtaClick}>
            Claim my credit
          </Link>
          <div className="mt-4 space-y-1 text-xs text-ds-gray-light-700">
            <p>Valid for 30 days &middot; New accounts only</p>
            <p>Credit applies to booking fees only, not meals</p>
          </div>
        </div>
      </div>
    </DialogContent>
  );
}
